import { useCallback, useEffect, useMemo, useState } from 'react';
import { sentenceCase } from 'change-case';
import { useDispatch } from 'react-redux';
// material
import CloseIcon from '@mui/icons-material/Close';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Select,
  MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { MdWatchLater } from 'react-icons/md';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user/index';
import { fDate, fDateTime1, fDateTime2 } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import CallCenterToolbar from './CallCenterToolbar';
import useDebounce from '../../utils/useDebounce';
import useCallCenterSelector from '../../store/Slice/CallCenterList/CallCenterListSelector';
import { getCallCenterList } from '../../store/Slice/CallCenterList/CallCenterListSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import {
  getLoanTypeData,
  getSourceListData,
  getStatusList
} from '../../store/Slice/Global/GlobalSlice';

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: '#fff',
  '&:nth-of-type(even)': { backgroundColor: '#fafbfc' },
  '&:hover': { backgroundColor: '#f1f5f9 !important' },
  '&:last-child td, &:last-child th': { border: 0 }
}));

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 11.5,
    fontWeight: 700,
    padding: '12px 14px',
    backgroundColor: '#ffffff',
    color: '#64748b',
    borderBottom: '1px solid #e2e8f0',
    letterSpacing: '0.5px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 14px',
    color: '#334155',
    borderBottom: '1px solid #f1f5f9'
  }
}));

const TABLE_HEAD = [
  { id: 'randomPhoneNumber', label: 'MOBILE NUMBER', alignRight: false },
  { id: 'loanType', label: 'LOAN TYPE', alignRight: false },
  { id: 'created', label: 'DATE', alignRight: false },
  { id: 'name', label: 'CUSTOMER NAME', alignRight: false },
  { id: 'city', label: 'CITY', alignRight: false },
  { id: 'source', label: 'SOURCE', alignRight: false },
  { id: 'statusCallCenter', label: 'STATUS', alignRight: false },
  { id: 'recommendation', label: 'RECOMMENDATION', alignRight: false },
  { id: 'modifiedOn', label: 'LAST UPDATE', alignRight: false },
  { id: 'noofcalls', label: 'NO OF CALLS', alignRight: false },
  { id: 'action', label: 'ACTION', alignRight: false, align: 'center' }
];

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function CallCenterList() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(600);
  const [openLoader, setOpenLoader] = useState(false);
  // const [openStatus, setOpenStatus] = useState(false);
  const [pageMenu, setPageMenu] = useState([]);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [page1, setPage1] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [selectLoanType, setSelectLoanType] = useState(' ');
  const [selectSource, setSelectSource] = useState(' ');
  const [selectStatus, setSelectStatus] = useState(' ');

  const { LoginData } = useLoginSelector();
  const { CallCenterData } = useCallCenterSelector();
  const callCenterListData = CallCenterData?.callCentreEntities || [];

  const dispatch = useDispatch();
  const debouncedSearch = useDebounce(filterName, 600);

  useEffect(() => {
    setHasNextPage((callCenterListData?.length || 0) >= rowsPerPage);
  }, [callCenterListData, rowsPerPage]);

  useEffect(() => {
    setPage1(1);
  }, [debouncedSearch]);

  const handleLoanSelectLoan = (e) => {
    setSelectLoanType(e.target.value);
  };
  const handleSelectSource = (e) => {
    setSelectSource(e.target.value);
  };

  const handleSelectStatus = (e) => {
    setSelectStatus(e.target.value);
  };

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = callCenterListData?.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = useMemo(() =>
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - (callCenterListData?.length || 0))
      : (0)[(page, rowsPerPage, callCenterListData)]
  );

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  // call center list
  const getCallCenterApi = useCallback(() => {
    const apiData = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 54,
      callCentreFilterModel: {
        fromLeadDate:
          filterDatesRange[0].startDate !== null ? fDateTime2(filterDatesRange[0].startDate) : null,
        toLeadDate:
          filterDatesRange[0].endDate !== null ? fDateTime2(filterDatesRange[0].endDate) : null,
        leadStageStatusId: selectStatus !== ' ' ? selectStatus : null,
        sourceTypeId: selectSource !== ' ' ? selectSource : null,
        loanTypeId: selectLoanType !== ' ' ? selectLoanType : null
      },
      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        pageSize: rowsPerPage,
        pageNumber: page1,
        sortOrder: order
      }
    };
    dispatch(getCallCenterList(apiData));
  }, [
    LoginData,
    filterDatesRange,
    selectStatus,
    selectSource,
    selectLoanType,
    debouncedSearch,
    rowsPerPage,
    page1,
    order
  ]);

  useEffect(() => {
    getCallCenterApi(); // call center list
    getLoanMasterApi(); // loan master list
    dispatch(getSourceListData()); // source list
    dispatch(getStatusList(54)); // status list
  }, [getCallCenterApi]);

  return (
    <Page title="Partner Management System || Call Center">
      <Container maxWidth="xl" sx={{ pb: 6, pt: 2 }}>
        {/* Top Header Row with Icon, Title, and Breadcrumb */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          sx={{ mb: 3.5, gap: 2 }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '12px',
                bgcolor: '#e0f2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0284c7'
              }}
            >
              <HeadsetMicOutlinedIcon sx={{ fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: '#0f172a',
                  fontSize: { xs: '20px', sm: '24px' },
                  letterSpacing: '-0.3px',
                  mb: 0.25
                }}
              >
                Call Center
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '13px' }}>
                Manage customer calls, interactions, and follow-ups.
              </Typography>
            </Box>
          </Stack>

          <Box>
            <BrudCrumbs />
          </Box>
        </Stack>

        <Card
          sx={{
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            overflow: 'hidden',
            bgcolor: '#ffffff'
          }}
        >
          <CallCenterToolbar
            numSelected={selected.length}
            filterName={filterName}
            setFilterName={setFilterName}
            onFilterName={handleFilterByName}
            parent="call-center"
            pageMenu={pageMenu}
            filterDatesRange={filterDatesRange}
            setFilterDatesRange={setFilterDatesRange}
            selectLoanType={selectLoanType}
            setSelectLoanType={setSelectLoanType}
            onFilterLoan={handleLoanSelectLoan}
            selectSource={selectSource}
            setSelectSource={setSelectSource}
            onFilterSource={handleSelectSource}
            onFilterStatus={handleSelectStatus}
            selectStatus={selectStatus}
            setSelectStatus={setSelectStatus}
            selected={selected}
          />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: 380, overflow: 'auto' }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={callCenterListData?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckBox="true"
                />
                <TableBody>
                  {callCenterListData &&
                    callCenterListData?.length > 0 &&
                    callCenterListData?.map((item, index) => {
                      const isItemSelected = selected.indexOf(item) !== -1;
                      return (
                        <StyledTableRow
                          hover
                          key={index}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox" sx={{ pl: 2.5 }}>
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, item)}
                              sx={{
                                color: '#cbd5e1',
                                '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#0284c7' }
                              }}
                            />
                          </TableCell>

                          <StyledTableCell align="left" sx={{ fontWeight: 600, color: '#0284c7' }}>
                            {item.mobile ? item.mobile : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.loanType ? item.loanType : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.leadDate ? fDate(item.leadDate) : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ fontWeight: 600, color: '#0f172a' }}>
                            {item.customerName ? item.customerName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.cityName ? item.cityName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.sourceTypeName ? item.sourceTypeName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                (item.callCenterStatus &&
                                  item.callCenterStatus === 'Not interested' &&
                                  'error') ||
                                (item.callCenterStatus &&
                                  item.callCenterStatus === 'Not Doable' &&
                                  'warning') ||
                                'success'
                              }
                              sx={{ textTransform: 'capitalize' }}
                            >
                              {item.callCenterStatus
                                ? sentenceCase(item.callCenterStatus)
                                : `${NOT_AVAILABLE}`}
                            </Label>
                            {item.callCenterStatus && item.callCenterStatus === 'Follow Up' ? (
                              <Tooltip
                                title={
                                  item.followUpDateTime ? fDateTime1(item.followUpDateTime) : ''
                                }
                                placement="top"
                                arrow
                              >
                                <IconButton className="followUpIcon" size="small" sx={{ ml: 0.5 }}>
                                  <MdWatchLater size={18} />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              ''
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.bankRecommendedName
                              ? item.bankRecommendedName
                              : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#64748b' }}>
                            {item.callCenterLastUpdatedOn
                              ? fDate(item.callCenterLastUpdatedOn)
                              : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="left" sx={{ color: '#0f172a', fontWeight: 600 }}>
                            {item.callCount ? item.callCount : `${NOT_AVAILABLE}`}
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            <UserMoreMenu rowId={item.leadId} parent="call-center" />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <StyledTableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {callCenterListData?.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <StyledTableCell
                        align="center"
                        colSpan={TABLE_HEAD.length + 1}
                        sx={{ py: 3 }}
                      >
                        <SearchNotFound searchQuery={filterName} />
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* Modern Pagination Footer */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 2, px: 3, borderTop: '1px solid #f1f5f9', bgcolor: '#ffffff', gap: 2 }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Typography sx={{ fontSize: '13px', color: '#64748b' }}>Showing</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#0f172a' }}>
                {callCenterListData?.length || 0} records
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={{ fontSize: '13px', color: '#64748b' }}>
                Page <span style={{ fontWeight: 600, color: '#0f172a' }}>{page1}</span>
              </Typography>

              <Stack direction="row" spacing={1}>
                <IconButton
                  disabled={page1 <= 1}
                  onClick={() => setPage1((p) => Math.max(1, p - 1))}
                  sx={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    p: 0.75,
                    bgcolor: '#ffffff',
                    color: '#0f172a',
                    '&.Mui-disabled': { opacity: 0.4, bgcolor: '#f8fafc' }
                  }}
                >
                  <ChevronLeftIcon sx={{ fontSize: 18 }} />
                </IconButton>
                <IconButton
                  disabled={!hasNextPage}
                  onClick={() => setPage1((p) => p + 1)}
                  sx={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    p: 0.75,
                    bgcolor: '#ffffff',
                    color: '#0f172a',
                    '&.Mui-disabled': { opacity: 0.4, bgcolor: '#f8fafc' }
                  }}
                >
                  <ChevronRightIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </Card>
        <Loader openLoader={openLoader} />
      </Container>
    </Page>
  );
}
